/*
 * @Author: katty 15032801667@163.com
 * @Date: 2023-01-05 13:51:59
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-01-28 10:44:28
 * @FilePath: \epec-ea\src\modules\projectA\api\pay\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "../request";
let baseUrl = request.getBaseUrl();
const server = {
  uploadPayCenterFile: `${baseUrl}/payment/epayAcountApply/uploadPayCenterFile`,  //上传产融专户申请人证件复印件
  getSupplierLicenceUrl: `${baseUrl}/payment/oss/getSupplierLicence`,  //下载附件
  queryPayCenterFile: `${baseUrl}/payment/epayAcountApply/getPayCenterFile`,  //查看图片

  getBankCardList: function() {
    return request.fetch("/payment/payAccount/queryOwnBankCard");
  },
  getBankList: function(params) {
    return request.post("/payment/cpcnPayment/queryCpcnBank", params);
  },
  submitBankData: function(params) {
    return request.post("/payment/payAccount/bindCard", params);
  },
  unBindBankCard: function(params) {
    return request.fetch("/payment/payAccount/unbindCard", params);
  },
  getAccountList: function(params) {
    return request.fetch("/payment/payAccount/queryOwnPayAccount", params);
  },
  withdrawCash: function(params) {
    return request.post("/payment/payAccount/withdrawCashFromCpcn", params);
  },
  bindCardConfirm: function(params) {
    return request.post("/payment/payAccount/verifyCard", params);
  },
  // 提现记录查询-分页
  withdrawCashPage: function(params) {
    return request.post("/payment/paymentRecord/withdrawCashPage", params);
  },
  // 支付记录查询- 分页
  transactionRecordPage: function(params) {
    return request.post("/payment/paymentRecord/page", params);
  },

  // 刷新支付信息 
  refresh: function(params) {
    return request.post("/payment/paymentRecord/refresh", params);
  },
  // 查询支付账号信息 
  queryPayAccountInfo: function(params) {
    return request.fetch("/payment/payAccount/queryPayAccountInfo", params);
  },
  //获取图片
  paymentGetSupplierLicence: function(params) {
    return request.fetch("/payment/oss/getSupplierLicence", params);
  },
  //获取图片
  getPayCenterFile: function(params) {
    return request.fetch("/payment/epayAcountApply/getPayCenterFile", params);
  },

  //修改账户信息
  modifyPayAccount: function(params) {
    return request.post("/payment/payAccount/modifyPayAccount", params);
  },

  // 提现按钮 接口新增
  queryAvailableBankCard: function(params) {
    return request.fetch("/payment/payAccount/queryAvailableBankCard", params);
  },
  //产融专户申请
  industryFinanceAccountApply: function(params) {
    return request.fetch("/payment/epayAcountApply/industryFinanceAccountApply", params);
  },
  //产融开户状态  校验企业是否开通结算账户
  financeAccountStatus: function(params) {
    return request.post("/payment/epayAcountApply/financeAccountStatus", params);
  },
  //产融专户申请
  financeAccountApply: function(params) {
    return request.post("/payment/epayAcountApply/financeAccountApply", params);
  },
  //产融专户申请资料
  financeAccountApplyDetail: function(params) {
    return request.post("/payment/epayAcountApply/financeAccountApplyDetail", params);
  },
  //判断当前企业是否在中金支付的白名单中，返回true或者false
  isInCpcnWhiteList: function(params) {
    return request.post("/user-center/companyConfig/isInCpcnWhiteList", params);
  },
  //中金支付 待开票查询-分页
  zhongJinQueryPage: function(params) {
    return request.post("/payment/paymentRecordMonth/queryPage", params);
  },
  //中金支付 申请开票
  applyPaymentInvoice(params) {
    return request.post('/payment/paymentInvoice/apply', params);
  },
  //中金支付 中金开票记录详情
  paymentInvoiceDetail(params) {
    return request.post('/payment/paymentInvoice/detail', params);
  },
  //中金开票记录查询
  queryPaymentInvoicePage(params) {
    return request.post('/payment/paymentInvoice/queryPage', params);
  },
  //中金开票 冲红
  paymentInvoiceVoiding(params) {
    return request.post('/payment/paymentInvoice/voiding', params);
  },


};
export default server;